import React from 'react';

import Link from 'next/link';
import styled from 'styled-components';

import CustomIcon, { SeturIcon } from '@components/utils/CustomIcon';

import { HeaderReservationsWrapper } from './styled';

interface Props {
  href: string;
  title?: string;
  icon?: SeturIcon;
}

const StyledLink = styled(Link)`
  font-size: 16px;
  margin: 0 8px;
`;

const MenuLinks = ({ href, title, icon }: Props) => {
  return (
    <StyledLink prefetch={false} href={href} passHref>
      <HeaderReservationsWrapper>
        <CustomIcon fontSize={20} icon={icon} paletteColor='grey300' />
        <span>{title}</span>
      </HeaderReservationsWrapper>
    </StyledLink>
  );
};

export default MenuLinks;
